import React from 'react';
import { motion } from 'framer-motion';
interface EditorialButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'outline';
  fullWidth?: boolean;
}
export function EditorialButton({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: EditorialButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium tracking-wide transition-all duration-300 rounded-sm font-serif';
  const variants = {
    primary: 'bg-[#B87333] text-[#FAF6F1] hover:bg-[#A0674B] shadow-sm hover:shadow-md',
    outline: 'border-2 border-[#B87333] text-[#B87333] hover:bg-[#B87333] hover:text-[#FAF6F1]'
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-1">
      {children}
    </motion.button>;
}